import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/40">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-5">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-xl text-primary-500"></i>
                </div>
                <span className="text-lg font-bold text-foreground-100 font-heading">
                  6080影视
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                免费高清电影在线观看平台，依托6080新视觉影视资源，每日更新最新大片，无需VIP享受流畅播放体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-500/20 text-foreground-500 hover:text-primary-400 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-500/20 text-foreground-500 hover:text-primary-400 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-500/20 text-foreground-500 hover:text-primary-400 transition-colors" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-5 font-heading">快速链接</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                    全部电影
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                    隐私政策
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                    服务条款
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-5 font-heading">电影分类</h4>
              <ul className="space-y-3">
                {categories.slice(1, 6).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-5 font-heading">联系我们</h4>
              <ul className="space-y-3">
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-foreground-600"></i>
                  </div>
                  service@6080ys.com
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-wechat-line text-foreground-600"></i>
                  </div>
                  微信公众号：6080影视
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line text-foreground-600"></i>
                  </div>
                  北京市朝阳区光华路SOHO
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-700">
              &copy; 2024 6080影视 - 6080新视觉影视 版权所有
            </p>
            <p className="text-xs text-foreground-700">
              本站资源来源于互联网，仅供交流学习使用，版权归原作者所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}